// Baseball bullpen roles a reliever can be tagged with on the Pitching page (several allowed). The closer is not a tag:
// he is the depth chart slot after the rotation. Used by the game sim (GameSim.baseball/Team.ts) and the depth page.
export const RP_ROLES = ["setup", "fireman", "closerBackup", "long", "strikeout", "mopup"] as const;
export type RpRole = (typeof RP_ROLES)[number];

export const RP_ROLE_INFO: Record<RpRole, { label: string; short: string; desc: string }> = {
	setup: { label: "Setup", short: "SU", desc: "7th and 8th innings of a close game (ahead by up to 3 or tied)" },
	fireman: { label: "Fireman", short: "FM", desc: "The most dangerous spot, from the 6th on: close game, runners in scoring position" },
	closerBackup: { label: "Closer backup", short: "CB", desc: "Closes when the closer can't (tired, hurt or already used)" },
	long: { label: "Long relief", short: "LR", desc: "Covers several innings when the starter leaves by the 5th" },
	strikeout: { label: "Strikeout", short: "K", desc: "Needs a strikeout: runner on third, fewer than two outs, close game" },
	mopup: { label: "Mop-up", short: "MU", desc: "Games already decided (ahead by 5+ or behind by 4+)" },
};
